import { render, staticRenderFns } from "./ApprovalText.vue?vue&type=template&id=6b884b7e&"
import script from "./ApprovalText.vue?vue&type=script&lang=js&"
export * from "./ApprovalText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports